<template>
    <div>
        <b-row class="mb-2">
            <b-col>
                <b-button @click="add" class="btn btn-light pull-right">{{Core.Definition.getDefinition('Nouvel établissement')}}</b-button>
            </b-col>
        </b-row>
        <router-view></router-view>
    </div>
</template>

<script>
    export default {
        name: 'BranchContainer',
        components: {
        },
        mounted() {
        },
        data () {
            return {
                Core: window.Core
            }
        },
        methods: {
            add() {
                if (this.$route.fullPath === window.Core.Definition.getDefinition('/systeme/etablissements/nouvel-etablissement')) {
                    location.reload()
                } else {
                    this.$router.push(window.Core.Definition.getDefinition('/systeme/etablissements/nouvel-etablissement'))
                }
            }
        }
    }
</script>
